module.exports = __webpack_public_path__ + "static/media/MyRequests.34af1083.svg";